import { Icon } from '@iconify/react';
import pieChart2Fill from '@iconify/icons-eva/pie-chart-2-fill';
import peopleFill from '@iconify/icons-eva/people-fill';
import shoppingBagFill from '@iconify/icons-eva/shopping-bag-fill';
import fileTextFill from '@iconify/icons-eva/file-text-fill';
import lockFill from '@iconify/icons-eva/lock-fill';

// ----------------------------------------------------------------------

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

const sidebarConfig = [
  {
    title: 'common.dashboard',
    path: '/dashboard/app',
    icon: getIcon(pieChart2Fill)
  },
  {
    title: 'common.suspects',
    path: '/dashboard/suspects',
    icon: getIcon(peopleFill)
  },
  {
    title: 'common.prospects',
    path: '/dashboard/prospects',
    icon: getIcon(shoppingBagFill)
  },
  {
    title: 'common.clients',
    path: '/dashboard/clients',
    icon: getIcon(fileTextFill)
  },
  {
    title: 'common.projects',
    path: '/dashboard/projects',
    icon: getIcon(lockFill)
  },
];

export default sidebarConfig;
